import { FC, useMemo } from 'react';
import { key, partTestId } from '@connect-x-app/shared-utils';

import { TabBar as TabBarType } from './TabBar.types';

import './tabBar.scss';

type Props = {
  selected?: TabBarType['id'];
  tabs: TabBarType[];
  testId?: string;
};

export const TabBar: FC<Props> = ({ selected, tabs, testId }) => {
  const handleTabClick = (tab: TabBarType) => {
    if (tab.onClick) {
      tab.onClick();
    }
  };

  const mappedTabs = useMemo(() => {
    return tabs.map(tab => ({
      ...tab,
      selected: tab.id === selected,
    }));
  }, [tabs, selected]);

  return (
    <div className="tab-bar" data-test={testId}>
      <ul className="tab-list">
        {mappedTabs.map(tab => (
          <li
            className={`tab-item ${tab.selected ? 'active' : ''}`}
            data-test={partTestId(testId, key(tab.id))}
            key={tab.id}
            onClick={() => handleTabClick(tab)}
          >
            {tab.text}
            <div key={tab.id}></div>
          </li>
        ))}
      </ul>
    </div>
  );
};
